export default class DashboardContants {
  static readonly Online = 'Online';
  static readonly Offline = 'Offline';
  static readonly TimedOut = 'TimedOut';
  static readonly Maintenance = 'Maintenance';
  static readonly ServiceIncidents = 'Service Incidents';
}

export const itemHeight = 48;
export const itemPaddingTop = 8;
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: itemHeight * 4.5 + itemPaddingTop,
      width: 250,
    },
  },
};
